import apiService from './apiService';

export default (function() {
	var servicePath = '/Tag';
	var CATEGORY_REGEX = /^Category \((.*)\)/;

	// Get the categories for a section
	function fetchCategories(section) {
		var url = servicePath + '/categories?section=' + section;

		return apiService.get(url);
	}

	function fetchFilters(section) {
		var url = servicePath + '/filters?section=' + section;

		return apiService.get(url);
	}

	function groups(section) {
		var url = servicePath + '/groups?section=' + section;

		return apiService.get(url);
	}

	function groupsSort(a, b) {
		var aIsCategory = CATEGORY_REGEX.test(a.name);
		var bIsCategory = CATEGORY_REGEX.test(b.name);
		var aIsKeyword = a.name === 'Keyword';
		var bIsKeyword = b.name === 'Keyword';

		if ((aIsCategory && !bIsCategory) || (!aIsKeyword && bIsKeyword)) {
			return -1;
		}
		if ((!aIsCategory && bIsCategory) || (aIsKeyword && !bIsKeyword)) {
			return 1;
		}
		return a.name.localeCompare(b.name);
	}

	function mappedGroupName(name) {
		if (!name) {
			return name;
		}
		const match = name.match(CATEGORY_REGEX);

		if (match && match[1]) {
			return match[1];
		}
		if (name === 'Keyword') {
			return 'Keywords';
		}
		return name;
	}

	function tags(groupId) {
		var url = servicePath + '?groupId=' + groupId;

		return apiService.get(url);
	}

	return {
		fetchCategories: fetchCategories,
		fetchFilters: fetchFilters,
		groups: groups,
		groupsSort: groupsSort,
		mappedGroupName: mappedGroupName,
		tags: tags
	};
})();